"use client";

import Image from "next/image";


const Featuredon = () => {
    const awards = [
        {
            img: "https://cdn.msu.edu.in/campus/CEGR.webp",
            alt: "Addressing the CEGR Fourth Summit on Education Alliances",
            text: "",
            subtext: "Addressing the CEGR Fourth Summit on Education Alliances"
        },
        {
            img: "https://cdn.msu.edu.in/campus/India-Greatest-Brands-and-Leaders.webp",
            alt: "Honoured with the India's Greatest Brands & Leaders 2023-24 Award by AsiaOne Magazine",
            text: "India Education",
            subtext: "Honoured with the India's Greatest Brands & Leaders 2023-24 Award by AsiaOne Magazine"
        },
        {
            img: "https://cdn.msu.edu.in/campus/conversation-with-Ms-Vandana-Yadav-IAS.webp",
            alt: " In conversation with Ms. Vandana Yadav, IAS, Principal Secretary, Department of Industry, Commerce & Enterprises and Managing Director, WBIDC, Government of West Bengal", text: "Ani News",
            subtext: " In conversation with Ms. Vandana Yadav, IAS, Principal Secretary, Department of Industry, Commerce & Enterprises and Managing Director, WBIDC, Government of West Bengal"
        },
                {
            img: "https://cdn.msu.edu.in/campus/SHRM.webp",
            alt: "Participating as the chairperson of a panel at the SHRM Tech 2.0, Conference & Expo, 2025", text: "Ani News",
            subtext: "Participating as the chairperson of a panel at the SHRM Tech 2.0, Conference & Expo, 2025"
        },
    ];

    const marqueeItems = [...awards, ...awards];

    return (
        <div className="w-full overflow-hidden">
            <div className="flex gap-4 marquee overflow-hidden" style={{ "--speed": "80s" }}>

                {marqueeItems.map((award, index) => (
                    <div
                        key={index}
                        className="min-w-[250px] md:min-w-[320px] lg:min-w-[500px] relative overflow-hidden 
              group transition-transform duration-700 hover:scale-105"
                    >
                        <Image
                            src={award.img}
                            alt={award.alt}
                            width={500}
                            height={300}
                            className="object-cover w-full h-70 md:h-70 lg:h-90 transition-transform 
              duration-700 group-hover:scale-110 overflow-hidden"
                        />

                        <div
                            className="absolute inset-0 z-10 opacity-100 overflow-hidden
              md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 transition-opacity duration-700"
                            style={{
                                background:
                                    "linear-gradient(180deg, rgba(8, 30, 45, 0) 0%, #081E2D 100%)",
                            }}
                        />

                        <div
                            className="overflow-hidden space-y-2 absolute bottom-2 md:bottom-4 lg:bottom-6 left-5 right-2 z-20 text-white 
              opacity-100 md:opacity-100 lg:opacity-0 md:group-hover:opacity-100 lg:group-hover:opacity-100 transition-opacity duration-700"
                        >
                            {/* <p className="text-[13px] md:text-[14px] opacity-90 w-full break-words leading-tight line-clamp-2 overflow-hidden"
                                style={{ fontFamily: "saans-bold" }}
                            >
                                {award.text}
                            </p> */}
                            <p className="text-[13px] md:text-[14px] opacity-90 w-full break-words leading-tight line-clamp-3 overflow-hidden"
                                style={{ fontFamily: "saans-regular" }}
                            >


                                {award.subtext}
                            </p>
                        </div>
                    </div>
                ))}

            </div>
        </div>
    );
};

export default Featuredon;
